module.exports = __webpack_public_path__ + "static/img/tool_service_2.e731465b.png";